exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cart-name-cell[data-v-1dae8e85]{\n  max-width: 250px;\n}\n#pb-menu-layout-1 .navbar-brand-box[data-v-1dae8e85] {\n  overflow: hidden;\n  max-height: 70px;\n}\n", ""]);

// exports
